<app-widget [widget-meta]="this.data"
  itemCount="{{ ( canvas.assignments$ | async)?.count }}"
  class="canvas-assignments"
  externalLink="https://kenanflagler.instructure.com"
  externalLinkText="Canvas"
  showHelp="true">
  @if (canvas.assignments$ | async; as results) {
    <div>
      @if (results.assignmentsByDate.length > 0) {
        @for (result of results.assignmentsByDate; track result) {
          <div class="card mb-3">
            <div class="card-header">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  {{result.Day}}
                </div>
                <div class="badge badge-primary badge-pill">
                  {{result.Assignments.length}}
                </div>
              </div>
            </div>
            <div class="card-body">
              <ul class="fa-ul">
                @for (assignment of result.Assignments; track assignment) {
                  <li class="mb-1">
                    <span class="fa-li">
                      <i class="fas fa-calendar-alt"></i>
                    </span>
                    <small>
                      <strong>{{assignment.DueAt}}</strong>
                      - <a target="_blank" href="{{assignment.Url}}">{{assignment.Name}}</a> <br />
                      {{assignment.CourseName}}&nbsp;({{assignment.Points}} points)
                    </small>
                  </li>
                }
              </ul>
            </div>
          </div>
        }
      } @else {
        <div class="card mb-3">
          <div class="card-body">
            <p class="text-muted text-center">No assignments found.</p>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="widget-loading text-center">
      <i class="fas fa-circle-notch fa-spin"></i>
    </div>
  }
</app-widget>
